import { isIncludeAcc } from "../helpers/isIncludeAcc";
import { isIncludeCardinal } from "../helpers/isIncludeCardinal";
import { isIncludeGmh } from "../helpers/isIncludeGmh";
import { isIncludeLandmark } from "../helpers/isIncludeLandmark";
import { isIncludePeakmade } from "../helpers/isIncludePeakmade";
import { isIncludeTdc } from "../helpers/isIncludeTdc";


export const PHONE_NUMBER = "(352) 327 - 4061, Option 2";
export const PHONE_NUMBER_NO_OPTION = "(352) 327 - 4061";
export const EMAIL_ADDRESS = "support@roomsync.com";
export const INFO_EMAIL_ADDRESS = "info@roomsync.com";
export const CLIENTS_EMAIL_ADDRESS = "clients@roomsync.com";

export const MAX_MATCH_GROUPS = "maxMatchGroups";
export const CO_ED_MATCHING = "coEdMatching";
export const RENEWAL_MATCHING = "renewalMatching";

export const DEFAULT_RESOURCE_URL =
  "https://drive.google.com/drive/folders/0BzEzvGMmH9nKQVVrdjZncmNraEE?resourcekey=0-B6AaWvFj1hSCF21j2KLRlQ&usp=sharing";
export const APT_RESOURCE_URL =
  "https://drive.google.com/drive/folders/0BzEzvGMmH9nKb0ZKS2JISnp1bDg?resourcekey=0-fG5IJEsjjnD6KeIA8n_M-A&usp=sharing";
export const CARDINAL_RESOURCE_URL = "https://drive.google.com/drive/folders/1-V7BEoBXr2F1tbt86tuMxXPZlo0CsWhj?usp=share_link";

export const ROOMSYNC_WEBSITE = "https://roomsync.com/";
export const ACC_CONTACT_URL = "https://roomsync.com/acc-contact";
export const LANDMARK_CONTACT_URL = "https://www.roomsync.com/help/landmark-contact";
export const CARDINAL_CONTACT_URL = "https://www.roomsync.com/help/cardinal-contact";
export const DEFAULT_CONTACT_URL = "https://roomsync.com/contact/";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const IS_STAGING =
    process.env.REACT_APP_API_URL?.includes("https://stagingapi.roomsync.com");

export const QUESTIONS_LIMIT = 20;
export const QUESTIONS_ANSWER_CHAR_LIMIT = 50;

export const IS_ACC_ORIGIN = isIncludeAcc(window.location.origin);
export const IS_CARDINAL_ORIGIN = isIncludeCardinal(window.location.origin);
export const IS_GMH_ORIGIN = isIncludeGmh(window.location.origin);
export const IS_LANDMARK_ORIGIN = isIncludeLandmark(window.location.origin);
export const IS_TDC_ORIGIN = isIncludeTdc(window.location.origin);
export const IS_PEAKMADE_ORIGIN = isIncludePeakmade(window.location.origin);


export const ResidentStatus = {
  All: "All",
  RenewingResident: "Renewing Resident",
  NewResident: "New Resident",
};

export const USER_PAGE_PATHNAME_REGEX = /^\/user\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;